/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Calcom_MissingInputs */

const en_coaching_calcom_missing = /** @type {(inputs: Coaching_Calcom_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduling is not configured yet (CALCOM_LINK). Your session is reserved — we will contact you by email to pick a time.`)
};

const id_coaching_calcom_missing = /** @type {(inputs: Coaching_Calcom_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjadwalan belum dikonfigurasi (CALCOM_LINK). Sesi kamu sudah dipesan — kami hubungi lewat email untuk memilih waktu.`)
};

/**
* | output |
* | --- |
* | "Scheduling is not configured yet (CALCOM_LINK). Your session is reserved — we will contact you by email to pick a time." |
*
* @param {Coaching_Calcom_MissingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_calcom_missing = /** @type {((inputs?: Coaching_Calcom_MissingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Calcom_MissingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_calcom_missing(inputs)
	return en_coaching_calcom_missing(inputs)
});